"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkIsTouchEventsSupported = void 0;

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var checkIsTouchEventsSupported = function checkIsTouchEventsSupported() {
  return (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && ('ontouchstart' in window || Boolean(window.navigator.maxTouchPoints));
};

exports.checkIsTouchEventsSupported = checkIsTouchEventsSupported;


//////////////////
// WEBPACK FOOTER
// ./node_modules/vanilla-swipe/lib/utils/checkIsTouchEventsSupported.js
// module id = 1036
// module chunks = 0